import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import {
  AutomaticMappingAction,
  AutomaticMappingRequestSchema,
  AutomaticMappingResponseSchema,
} from '../shared/schemas/automaticMapping.js';

export const postAutomaticMappingDeprecated = defaultApi.declareEndpoint({
  url: 'ga4-service/v2/utm-configs/$utmConfigId/automatic_mapping/' as const,
  method: 'POST',
  querySchema: AutomaticMappingRequestSchema,
  responseSchema: AutomaticMappingResponseSchema,
  snakeCaseQueryParams: true,
});

export const postAutomaticMapping = defaultClient.mutation({
  url: 'ga4-service/v3/utm-configs/$utmConfigId/automatic_mapping/' as const,
  method: 'POST',
  requestSchema: z.object({}),
  responseSchema: z.object({}),
  querySchema: z.object({
    action: AutomaticMappingAction,
  }),
  processResponse(data) {
    return data;
  },
});
